import React, { Component } from "react";
import ACTIONS from "../modules/action";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import data from "../data";
import styles from './questions.module.scss'
import choosePlan from "../utils/plan-chooser";

function calcPages(count) {
    return Math.floor(0.70 * count);
}

class Questions extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.changePages(10);
        this.props.changePlan(data.plans[0]);

    }

    changeSelection(evt) {
        const pages = evt.target.value;

        let plan = choosePlan(pages);

        this.props.changePages(pages);
        this.props.changePlan(plan);
    }

    render() {
        return (
            <div style={{padding: 50}}>
                <label>
                    Select An Example Page Usage
                    <select onChange={(evt) => this.changeSelection(evt)} className={styles.select}>
                        {data.plans.map(plan => (
                            <option key={plan.id} value={calcPages(plan.pages)}>{calcPages(plan.pages)} Pages - {plan.price} Plan Recommended</option>
                        ))}
                    </select>
                </label>
                <br/>
                <br/>
                <Link to={{
                    pathname: '/p2',
                }}>P2</Link>
                <br/>
                <br/>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => ({
    selectedPlan: state.selectedPlan,
    selectedPrinter: state.selectedPrinter,
    pagesPerMonth: state.pagesPerMonth,
});

const mapDispatchToProps = dispatch => ({
    changePages: pagesPerMonth => dispatch(ACTIONS.changePages(pagesPerMonth)),
    changePlan: plan => dispatch(ACTIONS.changePlan(plan)),
    changePrinter: printer => dispatch(ACTIONS.changePrinter(printer)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Questions);
